module.exports = __webpack_public_path__ + "static/media/launch-page-bg.b702d2f5.jpg";